import { ListItem } from '@chakra-ui/react'

const SectionHeader = ({ children }: { children: React.ReactNode }) => (
  <ListItem pt={8} pb={4} px={0}>
    <h4 className="thick">{children}</h4>
  </ListItem>
)

export default SectionHeader
